<!-- 课程管理 添加 -->
<template>
  <div>
    <div class="form_box__group__item">
      <div class="form_box__group__item__title">上课地址:</div>
      <div class="form_box__group__item__content ml-10">
        <el-input v-model="location" placeholder="例如：上海市静安区南京西路595号上海棋院" style="width:600px;" @change="onAddressChanged"></el-input>
        <el-button type="primary" class="ml-2" @click="confirmAddress" @keyup.enter="confirmAddress">搜索确认</el-button>
      </div>
      <div class="form_box__group__item__tool"></div>
    </div>
    <div class="form_box__group__item">
      <div>
        <div class="w-60 ml-2" style="margin-top: 10px;">
          <el-alert title="请确认地图中“蓝色角标”的位置，蓝色角标可以拖拽" type="warning"></el-alert>
        </div>
      </div>
    </div>

    <div class="map__container">
      <div id="container"></div>
      <div class="dimension">
        <div>经度:{{ lng }}</div>
        <div>纬度:{{ lat }}</div>
        <!-- {{mapAddress}} -->
      </div>
    </div>
  </div>
</template>


<script>
import { geoSearchApi } from "@/api/module/geo"

let tmap = null;
let QTool = null;
let marker = null;
let QGeometryEditor = null;
let localSearch = null;
let geocoder = null;

let defalutMapZoom = 17.2;


export default {
  name: "locationSelectorTian",
  data() {
    return {
      hasInitScript: false,
      location : "",
      lat : 0.0,
      lng : 0.0,
      mapGl: null,
      mapMarker: null,
      myGeo : null,
      mapAddress : "",
      mapaddresses : [],
      mapVal : [],
      loading : false,
      hasInit : false,
      point : null,
      index: -1

    };
  },
  methods:{
    init(){
      this.location = "";
      this.initMap();
      this.lng = 0
      this.lat = 0
    },

    initMap() {
      let _this = this;
      // 初始化 map

      // if(tmap != null){
      //     console.log("地图已存在 销毁地图")
      //     tmap.destroy();
      //     tmap = null;

      //     marker = null;
      //     QGeometryEditor = null;
      // }


      //定义map变量，调用 tmap.Map() 构造函数创建地图
      tmap = new T.Map('container');


      let centerLngLat = new T.LngLat(121.471839, 31.233858);
      tmap.centerAndZoom(centerLngLat, defalutMapZoom);

      // var marker = new T.Marker(centerLngLat);
      // tmap.addOverLay(marker);
      // marker.enableDragging();

      this.addPointerAndFocus(centerLngLat.lng, centerLngLat.lat)

      //创建对象 
      geocoder = new T.Geocoder();
      console.log("初始化地图 结束")
    },

    localSearchResult(val){
      console.log("localSearchResult",val)
    },

    emitDatas() {

      // marker
      console.log("emitDatas",marker)

      // 更新 lng / lat
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData,this.index);

    },

    initLocation(lng, lat,index,address){
      console.log("initLocation",lng,lat)
      this.addPointerAndFocus(lng, lat);

      this.lng = lng;
      this.lat = lat;
      this.location = address;
      this.index = index;

    },

    onAddressChanged(){
      this.emitDatas();
    },


    confirmAddress(){ 
      this.searchLocation();
    },

    showInfoM(e) {
      this.lat = e.lnglat.lat;
      this.lng = e.lnglat.lng;
    },

    handleSelectLocation(item) {
      this.lat = item.lat;
      this.lng = item.lng;
      this.updateBMap(this.lng, this.lat);
    },

    antiShake(fun, tim) {
      let timeout = null;
      let _this = this;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fun.call(_this, arguments);
        }, tim);
      };
    },

    updateBMap(lng, lat) {
      this.initMarker(lng,lat);
    },

    /* 根据地址解析位置信息 */
    async searchLocation(suc, fail) {
      if(this.loading){
        return;
      }

      this.loading = true;

      // 创建地址解析器实例         
      // sig: 'huhJ9uA6GWZJRriIzi0d9uFwbluNR0pZ',

      try{

        if(this.location != "" && !this.location.startsWith("上海")){
          this.location = "上海" + this.location;
        }

        tmap.clearOverLays();
        geocoder.getPoint(this.location, this.searchResult);



      } catch(e){
        this.$message.error(" 解析地址错误 ");
      } finally {
        this.loading = false;
      }

    },


    addPointerAndFocus(lng, lat) { 
      console.log("addPointerAndFocus",lng,lat)

      tmap.clearOverLays();

      let location = new T.LngLat(lng, lat);

      tmap.panTo(location, defalutMapZoom);
      var marker = new T.Marker(location);
      
      this.lat = lat;
      this.lng = lng;

      //向地图上添加标注
      tmap.addOverLay(marker);
      marker.enableDragging();

      marker.addEventListener("dragend", (val)=>{
        this.lng = val.lnglat.lng
        this.lat = val.lnglat.lat
        console.log("dragend",val)}
      );
    },


    setAddresses(addresses){
      console.log("setAddresses",addresses)
    },

    searchResult(result){
      console.log("searchResult",result)
      if(result.getStatus() == 0){

          // tmap.panTo(result.getLocationPoint(), defalutMapZoom);

          // var marker = new T.Marker(result.getLocationPoint());

          this.addPointerAndFocus(result.getLocationPoint().lng, result.getLocationPoint().lat);


          // this.lat = result.getLocationPoint().lat;
          // this.lng = result.getLocationPoint().lng;

          // //向地图上添加标注
          // tmap.addOverLay(marker);
      }else{
        this.$message.error("未成功搜索地址！");
        this.loading = false;
        console.log(result.getMsg());
      }
    }

  },

  watch:{

    lat(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    },

    lng(){
      let addressData = {
        lat: this.lat,
        lng: this.lng,
        location: this.location,
      };
      this.$emit("onAddressChanged", addressData);
    }
  },

  created() {

  },
};








// @ is an alias to /src
// declare var BMapGL: any;

</script>

<style scoped lang="scss">
.map__container {
  margin-left: 10px;
  width: 600px;
  height: 400px;
  position: relative;
  .dimension {
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(130%);
  }
}
.input__location {
  width: 400px;
}

#container {
  width: 100%;
  height: 100%;
}
</style>

